import { Environment } from '@dicetechnology/dice-doris';

export const getEnvironment = (env: string | undefined): Environment => {
    const environment = env?.toLowerCase();

    switch (environment) {
        case 'production':
        case Environment.PROD: {
            return Environment.PROD;
        }
        case 'staging':
        case Environment.STAGING: {
            return Environment.STAGING;
        }
        case Environment.QA: {
            return Environment.QA;
        }
        case Environment.QA2: {
            return Environment.QA2;
        }
        case Environment.QA3: {
            return Environment.QA3;
        }
        case 'develop':
        case 'development':
        case Environment.DEV: {
            return Environment.DEV;
        }
        default: {
            return Environment.PROD;
        }
    }
};
